module.exports = __webpack_public_path__ + "static/media/main.c973ea5a.png";